import { NgModule } from '@angular/core';
import { FormErrorScrollingService } from './form-error-scrolling.service';

@NgModule({
  providers: [FormErrorScrollingService]
})
export class FormErrorScrollingModule {}
